<template>
  <div class="fixed inset-0 flex items-center justify-center z-50">
    <div class="modal-overlay absolute inset-0 bg-black opacity-75 backdrop-blur-md"></div>
    <div class="modal-container bg-white w-full md:max-w-lg mx-4 md:mx-auto rounded-lg shadow-lg z-50 overflow-y-auto">
      <div class="modal-content py-4 text-left px-6">
        <div class="flex justify-between items-center pb-3">
          <h3 class="text-2xl font-bold">{{ title }}</h3>
          <button
            class="modal-close bg-emerald-400 text-white hover:bg-emerald-600 transition duration-300 ease-in-out transform hover:scale-105 rounded-lg px-3 py-1"
            @click="$emit('closeModal')"
          >
            x
          </button>
        </div>
        <hr class="mb-4" />
        <div class="modal-body">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

const props = defineProps({
  title: String,
});
</script>

<style scoped>
/* Modal styles */
.modal-overlay {
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-container {
  max-height: 100%;
}

.modal-content {
  border-radius: 0.5rem;
}

.modal-close {
  cursor: pointer;
}
</style>
